jQuery(document).ready(function($){
  if($('.o-testimonials-slider')[0]){
    $('.o-testimonials-slider__testimonials').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      appendArrows: $('.o-testimonials-slider__arrows'),
      appendDots: $('.o-testimonials-slider__dots')
    })
  }
})